import React, {useRef, useState} from "react";
import PageActions from "../../../../base/PageActions";
import ContentBox from "../../../../../components/content-box/ContentBox";
import Modal from "../../../../../components/modal/Modal";
import GalleryItem from "../../../../../model/GalleryItem";
import _http_service from "../../../../../services/HttpService";
import _image_service from "../../../../../services/ImageService";
import useFetchResult from "../../../../../hooks/UseFetchResult";
import '../../../../styles/Common.scss';
import './FanArtGalleryPage.scss';

interface FanArtGalleryPageProps {
}

const FanArtGalleryPage = (props: FanArtGalleryPageProps) => {

    const page: PageActions = new PageActions({
        title: `Fan Art Gallery - Chase the Fox`,
        description: `Art of Chase done by friends and fans! Would you like to submit something too? A form is available!`,
        keywords: ["fan art", "fan art gallery", "fan art submissions", "fan submissions", "submission form"],
        imgSrc: `chase/assets/chase_artist.png`,
        url: `galleries/fan-art`
    });

    const [modalIsOpen, setModalIsOpen] = useState<boolean>(false);
    const resultModalItem = useRef<GalleryItem | undefined>();

    const [getResult, hasFetchedResult, setFetchedResult] = useFetchResult<GalleryItem[]>([], () =>
        _http_service.getAllGalleryItems("fan-art")
            .then(response =>
                (!response || Object.keys(response).length === 0) ? [] : response
            ), []);

    const openFullArt = (id: string) => {
        _http_service.getGalleryItem("fan-art", id)
            .then(response => {
                if (!response || Object.keys(response).length === 0) {
                    resultModalItem.current = undefined;
                } else {
                    resultModalItem.current = response;
                    setModalIsOpen(true);
                }
            })
            .catch(() => setModalIsOpen(false))
            .finally(() => setFetchedResult(true));
    }

    return page.generateMetaContent(
        <>
            <Modal isOpen={modalIsOpen}
                   onClose={() => setModalIsOpen(false)}>
                <div className="gallery-modal-view">
                    {resultModalItem.current && <>
                        <div className="gallery-modal-header">
                            <h2 className="center headline">{resultModalItem.current.title}</h2>
                            <p>{resultModalItem.current.description}</p>
                        </div>
                        <img src={_image_service.getCdnImageSrc(resultModalItem.current.location)}
                             alt={resultModalItem.current.title}
                             title={resultModalItem.current.title}/>
                    </>}
                </div>
            </Modal>
            <ContentBox header="Fan Art">
                <p className="fanart-submit-description">
                    Chase is currently accepting submissions for fan art! If you would like to have your art displayed
                    in the website gallery, on the stream, or perhaps even featured in future videos, then
                    then <a href="https://forms.gle/WU8vfQLBJQ1kuD9a8"
                       target="_blank"
                       rel="noopener noreferrer">please use this form!</a>
                </p>
                <div className="gallery-item-list">
                    <ul>
                        {hasFetchedResult && getResult().map((item, index) => <li key={`fan-art-${index}`}>
                            <a onClick={() => openFullArt(item.id || '')}>
                                <img src={_image_service.getCdnImageSrc(item.location, 'thumbnail')}
                                     alt={`Fan art submission ${index+1}`}
                                     title="Click on this thumbnail to see the full art!"/>
                            </a>
                        </li>)}
                    </ul>
                </div>
            </ContentBox>
        </>
    );
}

export default FanArtGalleryPage;